export const removeLoadingScreen = () => {
  const element = document.getElementById("main-core-loading");
  if (!element) return;

  element.style.opacity = "0";
  setTimeout(() => element.remove(), 300);
};
